/** 오버레이 최소 표시 시간 (ms) */
export const OVERLAY_MIN_TIME_MS = 400;
